module.exports = __webpack_public_path__ + "static/media/girl-23.09e44ccf.svg";